// src/ESim.tsx
import { createIcon } from "@chakra-ui/icon";
import { Fragment, jsx, jsxs } from "react/jsx-runtime";
var ESim_default = createIcon({
  displayName: "ESim",
  viewBox: "0 0 24 24",
  path: /* @__PURE__ */ jsxs(Fragment, {
    children: [
      /* @__PURE__ */ jsx("rect", {
        opacity: "0",
        width: "24",
        height: "24",
        fill: "white",
        fillOpacity: "0"
      }),
      /* @__PURE__ */ jsx("path", {
        d: "M 19.988281 4 C 19.988281 2.898438 19.101562 2 18 2 L 10.828125 2 C 10.300781 2 9.789062 2.210938 9.410156 2.589844 L 4.589844 7.410156 C 4.210938 7.789062 4 8.300781 4 8.828125 L 4 20 C 4 21.101562 4.898438 22 6 22 L 18.011719 22 C 19.109375 22 20 21.101562 20 20 Z M 8 19 C 7.449219 19 7 18.550781 7 18 C 7 17.449219 7.449219 17 8 17 C 8.550781 17 9 17.449219 9 18 C 9 18.550781 8.550781 19 8 19 Z M 15 18 C 15 18.550781 15.449219 19 16 19 C 16.550781 19 17 18.550781 17 18 C 17 17.449219 16.550781 17 16 17 C 15.449219 17 15 17.449219 15 18 Z M 8 15 C 7.449219 15 7 14.550781 7 14 L 7 12 C 7 11.449219 7.449219 11 8 11 C 8.550781 11 9 11.449219 9 12 L 9 14 C 9 14.550781 8.550781 15 8 15 Z M 11 18 C 11 18.550781 11.449219 19 12 19 C 12.550781 19 13 18.550781 13 18 L 13 16 C 13 15.449219 12.550781 15 12 15 C 11.449219 15 11 15.449219 11 16 Z M 12 13 C 11.449219 13 11 12.550781 11 12 C 11 11.449219 11.449219 11 12 11 C 12.550781 11 13 11.449219 13 12 C 13 12.550781 12.550781 13 12 13 Z M 15 14 C 15 14.550781 15.449219 15 16 15 C 16.550781 15 17 14.550781 17 14 L 17 12 C 17 11.449219 16.550781 11 16 11 C 15.449219 11 15 11.449219 15 12 Z M 15 14",
        fillRule: "evenodd",
        clipRule: "evenodd",
        fill: "currentColor"
      })
    ]
  })
});

export {
  ESim_default
};
